import { Text, Textarea } from '@components/ui';
import { ApiUrl } from '@config/apiUrl';
import apiProtected from '@lib/api/apiClient';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SpecialNotesProps {
  jobData?: {
    id?: string | number;
  };
}

const SpecialNotes = ({ jobData }: SpecialNotesProps): JSX.Element => {
  const { t } = useTranslation();
  const [specialNotes, setSpecialNotes] = useState<string | null>(null);
  useEffect(() => {
    if (jobData?.id == null) return;
    apiProtected
      .get(
        `${ApiUrl.server_url}v1/rating-special-messages/?jobId=${jobData.id}`
      )
      .then((res) => {
        setSpecialNotes(res?.data.data?.specialMessage ?? null);
      });
  }, [jobData?.id]);

  return (
    <Box sx={{ mt: 2.5, display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'center' }}>
      <Grid container justifyContent="center" sx={{ mt: 2 }}>
        <Grid item xs={12} md={8}>
          <Text variant="subtitle" sx={{ fontSize: 18, fontWeight: 700 }}>
            {t('rating.specialNotes')}
          </Text>
          <Textarea
            placeholder={t('rating.notesTypingPlaceholder')}
            value={specialNotes ?? ''}
            InputProps={{ readOnly: true }}
            minRows={4}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SpecialNotes;
